<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :isLoading="isLoading"
    @close="onCloseModal"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-select
              name="state"
              label="استان"
              ref="state"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              :data-source="states"
              data-text-field="name"
              data-value-field="id"
              v-model="form.parent_id"
            />
            <bita-input
              ref="name"
              type="text"
              name="name"
              label="نام شهر"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.name"
            />
            <bita-input
              ref="lat"
              type="text"
              name="lat"
              label="Lat"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.latitude"
            />
            <bita-input
              ref="long"
              type="text"
              name="long"
              label="Long"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.longitude"
            />
            <bita-input
              ref="name"
              type="text"
              name="name"
              label="شعاع"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.deliver_radius"
            />
           <bita-input
              ref="name"
              type="text"
              name="ebl_id"
              label="ebl_id"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.ebl_id"
            />
          </div>
        </div>
      </bita-form>
      <div slot="footer" class="d-flex justify-content-center">
        <bita-bootbutton
          type="primary"
          title="ایجاد شهر"
          icon="fa fa-check"
          btn-width="150px"
          @click.native="handleSubmit()"
        />
        <bita-bootbutton
          class="mr-2"
          type="danger"
          title="بستن"
          icon="fas fa-times"
          btn-width="150px"
          data-dismiss="modal"
          @click.native="
            () => {
              $emit('change-status-modal');
            }
          "
        />
      </div>
    </div>
  </bita-modal>
</template>
<script>
export default {
  props: {
    modalId: {},
    isLoading: {},
    title: {},
    states: { type: Array, default: () => [] }, 

  },
  data() {
    return {
      colWidth: "col-12",
      form: {},
      isLoadingGetData: false,
    };
  },
  mounted() {
    // this.getStates();
  },
  methods: {
    // getStates() {
    //   this.isLoadingGetData = true;

    //   this.$persistClient("get", "cities?filter[province]=0")
    //     .then((res) => {
    //       this.states = res.data;
    //     })
    //     .finally((res) => {
    //       this.isLoadingGetData = false;

    //       this.toggleCreateModal();
    //     });
    // },
    toggleLoading() {
      this.$emit("isLoading");
    },
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-submit", this.form);
        }
      });
    },
    onCloseModal() {
      this.$refs.form.reset();

      this.form = {};
    },
  },
};
</script>
